/**
 * Helpers related to navigation and redirect handling for authentication flows
 * Centralizes the logic to determine whether a redirect should be suppressed
 * (e.g., during email verification or when a signup is in progress).
 */

export const shouldSuppressRedirect = (currentPath?: string): boolean => {
  const path = currentPath || window.location.pathname;
  const isSignupInProgress = sessionStorage.getItem('signup_in_progress') === 'true';
  return (
    path === '/verify-email' ||
    path === '/reset-password' ||
    path.startsWith('/accept-invite') ||
    path.startsWith('/auth/okta/callback') ||
    path.startsWith('/auth/microsoft/callback') ||
    isSignupInProgress
  );
};

export default shouldSuppressRedirect;
